import scenarioRegistry from './scenarioRegistry';

export function createScenario(index) {
    const scenarioTemplate = scenarioRegistry[index];
    return {
        ...scenarioTemplate,
    };
}
